export const isImage = (url) => {
  if (!url) return false;
  const extension = url.split(".").pop().toLowerCase();
  return ["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp"].includes(
    extension
  );
};

